import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BigNumber from 'bignumber.js';

import { useWidgetHelp } from 'src/hook';

import { selectCreatedQuote } from 'src/store/slice/quote/state';
import { selectPayment } from 'src/store/slice/payment/state';
import { selectMarketPrice } from 'src/store/slice/marketPrice/state';

import './price-overview.scss';

const PriceOverview: React.FC = (): JSX.Element => {
  const { t }: any = useTranslation();

  const { isRequesSuccess } = useWidgetHelp();

  const createdQuote = useSelector(selectCreatedQuote);
  const payment = useSelector(selectPayment);
  const marketPrice = useSelector(selectMarketPrice);

  const { source_currency_amount, source_currency_id } = createdQuote || marketPrice || { source_currency_amount: 0 };
  const { target_currency_amount_required, currency_id, target_currency_amount_left } = payment || {};

  const remained = new BigNumber(target_currency_amount_left || 0).toFixed();
  const targetCurrencyAmountRequired = new BigNumber(target_currency_amount_required || 0).toFixed();
  const sourceCurrencyAmount = new BigNumber(source_currency_amount).toFixed();

  return (
    <section className="price-overview">
      <p className="price-overview-price">{`${targetCurrencyAmountRequired} ${currency_id}`}</p>
      <p className="price-overview-remaining">
        {remained} {currency_id} <span className="label">{t('LABEL.REMAINING')}</span>
      </p>
      <p className={`price-overview-base-currency ${!isRequesSuccess ? 'skeleton-loader' : ''}`}>
        {source_currency_amount && source_currency_id ? `${sourceCurrencyAmount} ${source_currency_id}` : '~'}
        <span className="label">{t('LABEL.BASE_CURRENCY')}</span>
      </p>
    </section>
  );
};

export default PriceOverview;
